import { Component, OnInit } from '@angular/core';
import { CasesService } from '../cases/cases.service';

@Component({
  selector: 'app-production-userstation',
  templateUrl: './production-userstation.component.html',
  styleUrls: ['./production-userstation.component.css']
})
export class ProductionUserstationComponent implements OnInit {

  constructor(private _caseservice: CasesService) { }
  username: [any];
  stationdetails: any[] = [];

  ngOnInit() {
    debugger;
      const userid = localStorage.getItem('userid');
      console.log('Retrieved username from localStorage:', userid);
      if (userid) {
        this.getProductionUserstation(userid);
      } else {
        console.error("Username not found.");
      }
    }
  getProductionUserstation(userid) {
    debugger;
    this._caseservice.Getuserstationdetails(userid).subscribe(
      (data: any) => {
        console.log("stationdat:", data);
        this.stationdetails = data;
      },
      (error) => {
        console.error("Error occurred:", error);
      }
    );
  }
}


